export function redirectToLogin() {
  window.location.replace(
    `${process.env.REACT_APP_LAMBDATEST_HOME}/login`,
    '_self'
  );
}
